let map

let storeLocator
function vueStoreLocator() {
    storeLocator = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const defaultLocations = Vue.ref({
                act: {
                    name: "ACT",
                    center: { lat: -35.2735, lng: 149.0124 },
                    zoom: 11
                },
                nsw: {
                    name: "NSW",
                    center: { lat: -32.85, lng: 147.25 },
                    zoom: 6
                },
                nt: {
                    name: "NT",
                    center: { lat: -16.4914, lng: 132.5510 },
                    zoom: 6
                },
                qld: {
                    name: "QLD",
                    center: { lat: -22.5752, lng: 144.0848 },
                    zoom: 5
                },
                sa: {
                    name: "SA",
                    center: { lat: -31.0002, lng: 136.2092 },
                    zoom: 6
                },
                tas: {
                    name: "TAS",
                    center: { lat: -42.0409, lng: 146.8087 },
                    zoom: 7
                },
                vic: {
                    name: "VIC",
                    center: { lat: -36.9848, lng: 143.3906 },
                    zoom: 6
                },
                wa: {
                    name: "WA",
                    center: { lat: -25.6728, lng: 121.6283 },
                    zoom: 5
                }
            });

            map = new google.maps.Map(document.getElementById("map"), {
                center: { lat: -27.2380, lng: 133.9856 },
                zoom: 4
            });

            const fullStoreArray = Vue.ref(false);

            const filteredStores = Vue.ref(false);

            const fullStoreList = async () => {
                let req = `{
	                locations(first:250,sortKey:NAME) {
		                edges {
			                node {
                                id
				                address {
                                    phone
					                longitude
					                latitude
                                    formatted
                                    provinceCode
				                }
				                name
                          closedFrom: metafield(namespace:"store",key:"closed_from") {
                            value
                          }
                          closedTo: metafield(namespace:"store",key:"closed_to") {
                            value
                          }
			                }
		                }
	                }
                }`
                const opts = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                    },
                    body: JSON.stringify({ query: req })
                };

                try {
                    const storesResponse = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, opts);
                    let stores = await storesResponse.json();
                    stores.data.locations.edges = stores?.data?.locations?.edges?.filter(edge => !edge?.node?.name?.includes("pre-order") && !edge?.node?.name?.includes("warehouse"))
                    let storeData = stores.data.locations.edges.map(store => {
                        store.node.phoneLink = `tel:${store.node.address.phone}`
                        store.node.storeLink = `${shopifyConfig.storeURL}/pages/${store.node.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}-t-marts`
                        store.node.directionLink = `https://maps.google.com.au/maps?q=${store.node.address.latitude},${store.node.address.longitude}&z=15`;
                        store.node.highlight = false;
                        store.node.closedFrom = store.node.closedFrom?.value;
                        store.node.closedTo = store.node.closedTo?.value;
                        store.node.isClosed = storeSelector.isLocationClosed(store.node);
                        return store
                    });
                    fullStoreArray.value = storeData;
                    filteredStores.value = storeData;
                    storeSelector.storeList = storeData;
                    markStores(storeData)
                    return;
                } catch (error) {
                    console.error(`Error retrieving stores`, error)
                    return;
                }
            }

            fullStoreList();

            const storeSelector = window.storeSelector();

            const userLocation = Vue.computed(() => storeSelector.location);

            const selectedStore = Vue.computed(() => storeSelector.nearestStore);

            if (userLocation && fullStoreArray.value) {
                let storeDistance = fullStoreArray.value.map(store => {
                    distance = storeSelector.haversineFormula(Number(userLocation.latitude), Number(userLocation.longitude), store.node.address.latitude, store.node.address.longitude).toFixed(2);
                    return { ...store, distance };
                });
                storeDistance = storeDistance.sort((a, b) => a.distance - b.distance);
                filteredStores.value = storeDistance;
                storeSelector.storeList = storeDistance;
                Vue.watch(userLocation, (newLoc) => {
                    let storeDistance = fullStoreArray.value.map(store => {
                        distance = storeSelector.haversineFormula(Number(newLoc.latitude), Number(newLoc.longitude), store.node.address.latitude, store.node.address.longitude).toFixed(2);
                        return { ...store, distance };
                    });
                    storeDistance = storeDistance.sort((a, b) => a.distance - b.distance);
                    filteredStores.value = storeDistance;
                    storeSelector.storeList = storeDistance;
                    map.panTo({ lat: Number(newLoc.latitude), lng: Number(newLoc.longitude) });
                    map.setZoom(9);
                })
            } else if (userLocation.value) {
                Vue.watch(fullStoreArray, (newArray) => {
                    let storeDistance = newArray.map(store => {
                        distance = storeSelector.haversineFormula(Number(userLocation.latitude), Number(userLocation.longitude), store.node.address.latitude, store.node.address.longitude).toFixed(2);
                        return { ...store, distance };
                    });
                    storeDistance = storeDistance.sort((a, b) => a.distance - b.distance);
                    filteredStores.value = storeDistance;
                    storeSelector.storeList = storeDistance;
                    Vue.watch(userLocation, (newLoc) => {
                        let storeDistance = fullStoreArray.value.map(store => {
                            distance = storeSelector.haversineFormula(Number(newLoc.latitude), Number(newLoc.longitude), store.node.address.latitude, store.node.address.longitude).toFixed(2);
                            return { ...store, distance };
                        });
                        storeDistance = storeDistance.sort((a, b) => a.distance - b.distance);
                        filteredStores.value = storeDistance;
                        storeSelector.storeList = storeDistance;
                        map.panTo({ lat: Number(newLoc.latitude), lng: Number(newLoc.longitude) });
                        map.setZoom(9);
                    })
                })
            } else if (fullStoreArray.value) {
                Vue.watch(userLocation, (newLoc) => {
                    let storeDistance = fullStoreArray.value.map(store => {
                        distance = storeSelector.haversineFormula(Number(newLoc.latitude), Number(newLoc.longitude), store.node.address.latitude, store.node.address.longitude).toFixed(2);
                        return { ...store, distance };
                    });
                    storeDistance = storeDistance.sort((a, b) => a.distance - b.distance);
                    filteredStores.value = storeDistance;
                    storeSelector.storeList = storeDistance;
                    map.panTo({ lat: Number(newLoc.latitude), lng: Number(newLoc.longitude) });
                    map.setZoom(9);
                })
            } else {
                Vue.watch(fullStoreArray, (newArray) => {
                    if (newArray) {
                        Vue.watch(userLocation, (newLoc) => {
                            let storeDistance = fullStoreArray.value.map(store => {
                                distance = storeSelector.haversineFormula(Number(newLoc.latitude), Number(newLoc.longitude), store.node.address.latitude, store.node.address.longitude).toFixed(2);
                                return { ...store, distance };
                            });
                            storeDistance = storeDistance.sort((a, b) => a.distance - b.distance);
                            filteredStores.value = storeDistance;
                            storeSelector.storeList = storeDistance;
                            map.panTo({ lat: Number(newLoc.latitude), lng: Number(newLoc.longitude) });
                            map.setZoom(9);
                        })
                    }
                })
            }

            const markers = Vue.ref({});

            Vue.watch(selectedStore, (newStore) => {
                map.panTo({ lat: Number(newStore.node.address.latitude), lng: Number(newStore.node.address.longitude) });
                map.setZoom(15);
            })

            const markStores = (storeList) => {
                for (let i = 0; i < storeList.length; i++) {
                    markers.value[storeList[i].node.id] = new google.maps.Marker({
                        map: map,
                        position: { lat: storeList[i].node.address.latitude, lng: storeList[i].node.address.longitude },
                        icon: `https:${bluePin}`,
                        title: storeList[i].node.name
                    });
                }
            }

            const selectState = (state) => {
                map.panTo(defaultLocations.value[state.toLowerCase()].center);
                map.setZoom(defaultLocations.value[state.toLowerCase()].zoom);
                let stateStores = fullStoreArray.value.filter(store => store.node.address.provinceCode == state);
                stateStores = stateStores.sort((a, b) => a.node.name.localeCompare(b.node.name));
                filteredStores.value = stateStores;
            }

            const locationInput = Vue.ref("");

            const listSuburbs = Vue.ref(false);

            const listPostcodes = Vue.ref(false);

            storeSelector.getLocationInfo().then(([postcodes, suburbs]) => {
                Vue.watch(locationInput, (newInput, oldInput) => {
                    if (newInput.length < oldInput.length) {
                        listSuburbs.value = false
                        listPostcodes.value = false
                    }
                    storeSelector.inputListener(newInput, listSuburbs, listPostcodes, postcodes, suburbs)
                })
            })


            const setLocation = (name, lat, long) => {
                listSuburbs.value = false;
                listPostcodes.value = false;
                storeSelector.locationSelect(name, lat, long);
            }

            const highlightStore = (index) => {
                filteredStores.value[index].node.highlight = true;
                map.panTo({ lat: filteredStores.value[index].node.address.latitude, lng: filteredStores.value[index].node.address.longitude });
                map.setZoom(15);
                for (let i = 0; i < filteredStores.value.length; i++) {
                    if (i != index) {
                        filteredStores.value[i].node.highlight = false;
                    }
                }
            }

            return {
                selectState,
                defaultLocations,
                fullStoreArray,
                filteredStores,
                setLocation,
                locationInput,
                listSuburbs,
                listPostcodes,
                highlightStore,
            }
        }
    })
    storeLocator.use(window.VueAppGlobals.pinia);
    storeLocator.mount('#storeLocator');
}

if (window.Vue && window.Pinia) {
    vueStoreLocator();
} else {
    window.addEventListener('vue-ready', vueStoreLocator);
}
